// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgClose = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color ?? 'currentColor'}
      d="m9.424 8 4.27-4.271a.983.983 0 0 0 0-1.424.983.983 0 0 0-1.423 0L8 6.576l-4.271-4.27a.983.983 0 0 0-1.424 0 .983.983 0 0 0 0 1.423L6.576 8l-4.27 4.271a.983.983 0 0 0 0 1.424c.202.203.508.305.71.305.204 0 .51-.102.713-.305L8 9.424l4.271 4.271c.204.203.509.305.712.305.204 0 .508-.102.712-.305a.983.983 0 0 0 0-1.424z"
    />
  </svg>
)
export default SvgClose
